import { Skeleton, Slot, Text, Anchor } from '@costar-ui/components';
import React from 'react';

var Company = function Company(props) {
  var name = props.name,
    linkHref = props.linkHref,
    _props$target = props.target,
    target = _props$target === void 0 ? '_blank' : _props$target,
    currentlyWithLabel = props.currentlyWithLabel,
    onClick = props.onClick,
    isLoading = props.isLoading,
    testId = props.testId;
  return isLoading ? /*#__PURE__*/React.createElement(Skeleton, {
    width: "full",
    height: "1.25",
    className: "csg-tw-skeleton-company-name"
  }) : name && /*#__PURE__*/React.createElement(Slot, {
    gap: "sm",
    testId: testId
  }, currentlyWithLabel ? /*#__PURE__*/React.createElement(Text, {
    "automation-id": "currently-with-company-label",
    className: "wrap-anywhere"
  }, currentlyWithLabel) : null, name ? linkHref ? /*#__PURE__*/React.createElement(Anchor, {
    href: linkHref,
    target: target,
    variant: "primary-md",
    onClick: onClick,
    className: "wrap-anywhere",
    testId: "company-name-link"
  }, name) : /*#__PURE__*/React.createElement(Text, {
    testId: "company-name",
    className: "wrap-anywhere"
  }, name) : null);
};

export { Company };
//# sourceMappingURL=company.esm.js.map
